import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
function CollapsibleProductSummary({
  product,
  defaultOpen,
  children
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const price = product.retailPrice != null ? `$${Number(product.retailPrice).toFixed(2)}` : "";
  const rating = product.reviewsRating != null ? `★ ${Number(product.reviewsRating).toFixed(1)}` : "";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        overflow: "hidden",
        margin: "8px 0"
      },
      children: [
        /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            onClick: () => setIsOpen((o) => !o),
            style: {
              display: "flex",
              alignItems: "center",
              gap: 8,
              width: "100%",
              padding: "8px 12px",
              background: "#fafafa",
              border: "none",
              cursor: "pointer",
              fontSize: 13,
              color: "#333",
              textAlign: "left"
            },
            children: [
              /* @__PURE__ */ jsxs("span", { style: { flex: 1, fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, children: [
                product.brandName ? `${product.brandName} · ` : "",
                product.title
              ] }),
              price && /* @__PURE__ */ jsx("span", { style: { color: "#555", whiteSpace: "nowrap" }, children: price }),
              rating && /* @__PURE__ */ jsx("span", { style: { color: "#555", whiteSpace: "nowrap" }, children: rating }),
              /* @__PURE__ */ jsx("span", { style: { fontSize: 10, color: "#888", marginLeft: 4 }, children: isOpen ? "▲" : "▼" })
            ]
          }
        ),
        isOpen && /* @__PURE__ */ jsx("div", { style: { padding: "0 4px 4px" }, children })
      ]
    }
  );
}
export {
  CollapsibleProductSummary
};
//# sourceMappingURL=CollapsibleProductSummary.js.map
